import { Typography } from '@interstate/components/Typography';
import type { FC, ReactNode } from 'react';
import { cashAmountPaidNumericInputStyle, InputWrapper } from '../dealSummary/common/ComponentLabelStyle';

type CashFieldLayoutProps = {
    variant: 'summary' | 'slideout';
    label: string;
    children: ReactNode;
};

/**
 * Shared wrapper for the Cash Due Today / Cash Down fields. The summary variant renders the input
 * alone (label is shown natively on the field); the slideout variant adds a standalone heading above
 * the input. Shared by the editable (CashAmountPaidView) and read-only (ReadOnlyCashField) fields.
 */
const CashFieldLayout: FC<CashFieldLayoutProps> = ({ variant, label, children }) => {
    if (variant === 'summary') {
        return <div style={cashAmountPaidNumericInputStyle}>{children}</div>;
    }

    return (
        <div style={cashAmountPaidNumericInputStyle}>
            <Typography tag="span" variant="h4">
                {label}
            </Typography>
            <InputWrapper>{children}</InputWrapper>
        </div>
    );
};

export default CashFieldLayout;
